import { render } from "./timecardDetails.vue?vue&type=template&id=4ad63fc5"
import script from "./timecardDetails.vue?vue&type=script&lang=js"
export * from "./timecardDetails.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4ad63fc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ad63fc5', script)) {
    api.reload('4ad63fc5', script)
  }
  
  module.hot.accept("./timecardDetails.vue?vue&type=template&id=4ad63fc5", () => {
    api.rerender('4ad63fc5', render)
  })

}

script.__file = "src/components/timecardDetails.vue"

export default script